import { MsalAuthenticationResult } from "@azure/msal-react";

export const ErrorComponent: React.FC<MsalAuthenticationResult> = ({error}) => {
    return <h3>An Error Occurred: {error ? error.errorCode : "unknown error"}</h3>;
}